import { List, Create, Details } from "../Components/index.js";

export default [
    {
        path: "/letter/event",
        component: List,
        name: "letter.event",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/event/create",
        component: Create,
        name: "letter.event.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/event/:id/view",
        component: Details,
        name: "letter.event.view",
        meta: {
            requiresAuth: true,
        },
    },
];
